export default __webpack_public_path__ + "static/media/wave.049f0000.webp";